"use strict";
// Copyright (C) Microsoft Corporation. All rights reserved.
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyPressState = void 0;
var KeyPressState;
(function (KeyPressState) {
    KeyPressState[KeyPressState["Down"] = 1] = "Down";
    KeyPressState[KeyPressState["Up"] = 0] = "Up";
    KeyPressState[KeyPressState["Reset"] = -1] = "Reset";
})(KeyPressState || (exports.KeyPressState = KeyPressState = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoia2V5UHJlc3NTdGF0ZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy90eXBlcy9rZXlQcmVzc1N0YXRlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSw0REFBNEQ7OztBQUU1RCxJQUFZLGFBSVg7QUFKRCxXQUFZLGFBQWE7SUFDckIsaURBQVEsQ0FBQTtJQUNSLDZDQUFNLENBQUE7SUFDTixvREFBVSxDQUFBO0FBQ2QsQ0FBQyxFQUpXLGFBQWEsNkJBQWIsYUFBYSxRQUl4QiJ9